import { WSCard, WSText } from "@wingspanhq/fe-component-library";
import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryRequirementsList } from "../../../query/requirements/queries/useQueryRequirementsList";
import { useQueryPayerRows } from "../../../query/search/payer/queries/useQueryPayerRows";
import { getPayerName } from "../../Payers/utils/getPayerNames";

export const CardTaxVerificationRequirementRequester = () => {
  const userId = useUserId();

  const queryRequirements = useQueryRequirementsList({
    filter: {
      payeeId: userId,
      payerPayeeEngagementIds: {
        "!=": "null"
      },
      requirementType: "TaxVerification" as RequirementType
    }
  });

  const payerIds = (queryRequirements.data || []).map(
    requirement => requirement.payerId
  );

  const queryPayers = useQueryPayerRows({
    filter: {
      payerId: {
        in: payerIds
      }
    }
  });

  const payerNames = (queryPayers.data || []).map(payer => getPayerName(payer));

  return (
    <WSCard header="Taxpayer info">
      <WSText.ParagraphSm color="gray600">
        Complete your account setup by providing your taxpayer information below
        as required by {payerNames.join(", ")}
      </WSText.ParagraphSm>
    </WSCard>
  );
};
